export const rules = {
	// Card titles
	"rules.card.rules.title": "Правила",
	"rules.card.pointsAllocation.title": "Разпределение на точки",
	"rules.card.rulesContinued.title": "Правила (продължение)",
	"rules.card.weeklyPrizes.title": "Структура на седмичните награди",

	// Main rules content
	"rules.intro":
		'Всички термини с главни букви, използвани в тези правила (<strong>"Правилата"</strong>), ще носят определението, приписано им в общите условия (<strong>"Общите условия"</strong>).',

	"rules.temporary_notice":
		"Моля, имайте предвид, че победителите на награди за периода от 19 декември 2025 г. до 2 януари 2026 г. ще получат наградите си в рамките на 7 (седем) дни, считано от 6 януари 2026 г.",

	"rules.rule1":
		"Участниците могат да печелят точки, като правилно предскажат резултата на всяка от петте (5) игри всяка седмица/кръг (според случая), свързани със спортното състезание, към което се отнася играта Betway Scores BW ScorePredict, например <em>английската Премиер лига</em> и др. Състезанието Betway Scores BW Score Predict ще започне на 11 март 2025 г. и ще завърши в края на футболния сезон 2025/2026.",

	"rules.rule2.main": "Участниците могат да печелят допълнителни бонус точки, като правилно предскажат следното във всяка от петте (5) игри:",
	"rules.rule2.a": "Правилен краен резултат",
	"rules.rule2.b": "Правилен победител",
	"rules.rule2.c": "Правилни голове на домакините",
	"rules.rule2.d": "Правилни голове на гостите",
	"rules.rule2.e": "Правилна голова разлика",

	"rules.rule3": "Всяка седмица/кръг се съотнася с кръговете на това спортно състезание.",

	"rules.rule4": "Точките се разпределят както следва за всяка от следните правилни прогнози от Участника всяка седмица/кръг:",

	// Points allocation
	"rules.points.correctScore": "Правилен краен резултат",
	"rules.points.correctScoreValue": "50",
	"rules.points.correctWinner": "Правилен победител",
	"rules.points.correctWinnerValue": "5",
	"rules.points.homeGoals": "Правилни голове на домакините",
	"rules.points.homeGoalsValue": "5",
	"rules.points.awayGoals": "Правилни голове на гостите",
	"rules.points.awayGoalsValue": "5",
	"rules.points.goalDifference": "Правилна голова разлика",
	"rules.points.goalDifferenceValue": "5",

	// Continued rules
	"rules.rule5":
		"Участниците могат да правят промени в прогнозите си по всяко време, до 15 минути преди началото на всяка от игрите от съответната седмица/кръг.",

	"rules.rule6":
		"Всички регистрирани потребители на Betway Scores и/или BW Scores са допустими да играят Betway Scores BW ScorePredict, но само участници с верифициран Betway акаунт, в момента когато наградите трябва да бъдат присъдени, са допустими да печелят награди. Промени в резултатите от мача според точка 2. по-горе, които настъпят след присъждането на наградите (например анулиране на резултата), няма да бъдат разглеждани ретроспективно.",

	"rules.rule7":
		"Квалифицираният и допустим Участник, който завърши сезона на първо място и има Betway акаунт, ще бъде победителят на Голямата награда за сезона и ще спечели пътуване за двама (2) да гледа Арсенал в Лондон, включително полети (ако е необходимо), настаняване (ако е необходимо) и £500 джобни пари.",

	"rules.rule8":
		"Ако победителят на Голямата награда за сезона не може да пътува поради липса на валиден паспорт и/или виза и/или друго ограничение, той ще получи награда от €5,000 в брой салдо, или приблизителния еквивалент в местна валута към датата на започване на състезанието (£4,500, R100,000 или GH₵ 60,000), в своя Betway акаунт при завършване на състезанието.",

	"rules.rule9":
		"Победителят на Голямата награда за сезона може да избере да не приеме преживяването и вместо това да приеме награда от €5,000 в брой салдо, или приблизителния еквивалент в местна валута към датата на започване на състезанието (£4,500, R100,000 или GH₵ 60,000), в своя Betway акаунт.",

	"rules.rule10":
		'Седмичните награди ще бъдат присъдени на "Топ 10" изпълнителите всяка седмица/кръг, които имат валиден Betway акаунт за залагания. Ако изпълнител от Топ 10 няма Betway акаунт за залагания, той няма да получи Седмична награда.',

	"rules.rule11": "Седмичните места от 1 до 10 ще спечелят следните суми в брой салдо, в зависимост от техния регион, в своя Betway акаунт.",

	"rules.rule12":
		"Седмичните награди ще бъдат присъдени в рамките на 7 (седем) дни след финализирането на резултатите от тази седмица, а Голямата награда ще бъде присъдена в рамките на 7 (седем) дни след завършването на състезанието Betway Scores BW Score Predict.",

	"rules.rule13":
		"В случай на равенство за Седмичните награди, салдото в брой за тази позиция (и съответните позиции под нея, които са засегнати от равенството) ще бъде разделено равномерно между равните участници.",

	"rules.rule14":
		"В случай на равенство за Голямата награда, ще бъде използван механизъм за произволен избор, за да се избере само един от равните участници като победител на Голямата награда.",

	// Weekly prize table data
	"rules.weeklyPrizes.position1.eur": "€150",
	"rules.weeklyPrizes.position1.gbp": "£150",
	"rules.weeklyPrizes.position1.zar": "R3000",
	"rules.weeklyPrizes.position1.ghs": "GH₵2000",

	"rules.weeklyPrizes.position2.eur": "€100",
	"rules.weeklyPrizes.position2.gbp": "£100",
	"rules.weeklyPrizes.position2.zar": "R2000",
	"rules.weeklyPrizes.position2.ghs": "GH₵1250",

	"rules.weeklyPrizes.position3.eur": "€75",
	"rules.weeklyPrizes.position3.gbp": "£75",
	"rules.weeklyPrizes.position3.zar": "R1500",
	"rules.weeklyPrizes.position3.ghs": "GH₵1000",

	"rules.weeklyPrizes.position4.eur": "€50",
	"rules.weeklyPrizes.position4.gbp": "£50",
	"rules.weeklyPrizes.position4.zar": "R1000",
	"rules.weeklyPrizes.position4.ghs": "GH₵600",

	"rules.weeklyPrizes.position5.eur": "€40",
	"rules.weeklyPrizes.position5.gbp": "£40",
	"rules.weeklyPrizes.position5.zar": "R800",
	"rules.weeklyPrizes.position5.ghs": "GH₵500",

	"rules.weeklyPrizes.position6.eur": "€30",
	"rules.weeklyPrizes.position6.gbp": "£30",
	"rules.weeklyPrizes.position6.zar": "R600",
	"rules.weeklyPrizes.position6.ghs": "GH₵400",

	"rules.weeklyPrizes.position7.eur": "€20",
	"rules.weeklyPrizes.position7.gbp": "£20",
	"rules.weeklyPrizes.position7.zar": "R400",
	"rules.weeklyPrizes.position7.ghs": "GH₵250",

	"rules.weeklyPrizes.position8.eur": "€15",
	"rules.weeklyPrizes.position8.gbp": "£15",
	"rules.weeklyPrizes.position8.zar": "R300",
	"rules.weeklyPrizes.position8.ghs": "GH₵200",

	"rules.weeklyPrizes.position9.eur": "€10",
	"rules.weeklyPrizes.position9.gbp": "£10",
	"rules.weeklyPrizes.position9.zar": "R200",
	"rules.weeklyPrizes.position9.ghs": "GH₵100",

	"rules.weeklyPrizes.position10.eur": "€10",
	"rules.weeklyPrizes.position10.gbp": "£10",
	"rules.weeklyPrizes.position10.zar": "R200",
	"rules.weeklyPrizes.position10.ghs": "GH₵100",

	// Table headers
	"rules.weeklyPrizes.header.position": "# За кръг",
	"rules.weeklyPrizes.header.eur": "EUR",
	"rules.weeklyPrizes.header.gbp": "GBP",
	"rules.weeklyPrizes.header.zar": "ZAR",
	"rules.weeklyPrizes.header.ghs": "GHS",
};
